import React from "react";

export const PreloadImovelDetail = data => {
  return (
    <>
      <svg
        width="100%"
        viewBox="0 0 1848 792"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
        role="img"
        aria-label="Carregando imóvel"
      >
        <defs>
          <linearGradient
            id="base"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
          >
            <stop offset="0%" stopColor="#eef1f5" />
            <stop offset="50%" stopColor="#e5e8ed" />
            <stop offset="100%" stopColor="#eef1f5" />
          </linearGradient>

          <linearGradient
            id="shine1"
            x1="-180"
            y1="0"
            x2="40"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#fff" stopOpacity="0" />
            <stop offset=".42" stopColor="#fff" stopOpacity="0" />
            <stop offset=".5" stopColor="#fff" stopOpacity=".18" />
            <stop offset=".58" stopColor="#fff" stopOpacity="0" />
            <stop offset="1" stopColor="#fff" stopOpacity="0" />

            <animate
              attributeName="x1"
              values="-180;420;-180"
              dur="3.8s"
              begin="0s"
              repeatCount="indefinite"
            />

            <animate
              attributeName="x2"
              values="40;640;40"
              dur="3.8s"
              begin="0s"
              repeatCount="indefinite"
            />
          </linearGradient>

          <linearGradient
            id="shine2"
            x1="-220"
            y1="0"
            x2="20"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#fff" stopOpacity="0" />
            <stop offset=".44" stopColor="#fff" stopOpacity="0" />
            <stop offset=".5" stopColor="#fff" stopOpacity=".15" />
            <stop offset=".56" stopColor="#fff" stopOpacity="0" />
            <stop offset="1" stopColor="#fff" stopOpacity="0" />

            <animate
              attributeName="x1"
              values="-220;500;-220"
              dur="4.7s"
              begin=".85s"
              repeatCount="indefinite"
            />

            <animate
              attributeName="x2"
              values="20;740;20"
              dur="4.7s"
              begin=".85s"
              repeatCount="indefinite"
            />
          </linearGradient>

          <linearGradient
            id="shine3"
            x1="-150"
            y1="0"
            x2="80"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#fff" stopOpacity="0" />
            <stop offset=".43" stopColor="#fff" stopOpacity="0" />
            <stop offset=".5" stopColor="#fff" stopOpacity=".13" />
            <stop offset=".57" stopColor="#fff" stopOpacity="0" />
            <stop offset="1" stopColor="#fff" stopOpacity="0" />

            <animate
              attributeName="x1"
              values="-150;460;-150"
              dur="4.2s"
              begin="1.55s"
              repeatCount="indefinite"
            />

            <animate
              attributeName="x2"
              values="80;690;80"
              dur="4.2s"
              begin="1.55s"
              repeatCount="indefinite"
            />
          </linearGradient>

          <clipPath id="clipPage">
            <rect
              width="1848"
              height="792"
              rx="8"
            />
          </clipPath>
        </defs>

        <g clipPath="url(#clipPage)">
          <g>
            <rect
              x="14"
              y="21"
              width="601"
              height="418"
              rx="7"
              fill="url(#base)"
            />

            <rect
              x="14"
              y="21"
              width="601"
              height="418"
              rx="7"
              fill="url(#shine1)"
              opacity=".7"
            />

            <animate
              attributeName="opacity"
              values=".84;1;.9;.84"
              dur="3.1s"
              begin=".15s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="626"
              y="21"
              width="601"
              height="418"
              rx="7"
              fill="url(#base)"
            />

            <rect
              x="626"
              y="21"
              width="601"
              height="418"
              rx="7"
              fill="url(#shine2)"
              opacity=".7"
            />

            <animate
              attributeName="opacity"
              values=".87;1;.82;.87"
              dur="4s"
              begin=".95s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="1239"
              y="21"
              width="601"
              height="418"
              rx="7"
              fill="url(#base)"
            />

            <rect
              x="1239"
              y="21"
              width="601"
              height="418"
              rx="7"
              fill="url(#shine3)"
              opacity=".65"
            />

            <animate
              attributeName="opacity"
              values=".82;1;.88;.82"
              dur="3.6s"
              begin="1.7s"
              repeatCount="indefinite"
            />
          </g>

          <g
            fill="#cbd1da"
            opacity=".55"
          >
            <path
              d="
                M170 49
                L260 103
                L260 341
                L170 391
                Z
              "
            />

            <rect
              x="48"
              y="141"
              width="98"
              height="100"
              rx="3"
            />

            <rect
              x="273"
              y="148"
              width="75"
              height="191"
              rx="2"
            />

            <rect
              x="391"
              y="148"
              width="75"
              height="191"
              rx="2"
            />

            <rect
              x="798"
              y="48"
              width="82"
              height="52"
              rx="5"
            />

            <rect
              x="946"
              y="48"
              width="82"
              height="52"
              rx="5"
            />

            <rect
              x="798"
              y="135"
              width="82"
              height="53"
              rx="5"
            />

            <rect
              x="946"
              y="135"
              width="82"
              height="53"
              rx="5"
            />

            <rect
              x="798"
              y="227"
              width="82"
              height="54"
              rx="5"
            />

            <rect
              x="946"
              y="227"
              width="82"
              height="54"
              rx="5"
            />

            <rect
              x="798"
              y="326"
              width="82"
              height="55"
              rx="5"
            />

            <rect
              x="946"
              y="326"
              width="82"
              height="55"
              rx="5"
            />

            <rect
              x="1410"
              y="77"
              width="160"
              height="153"
              rx="3"
            />

            <path
              d="
                M1388 231
                L1594 231
                L1644 298
                L1343 298
                Z
              "
            />

            <rect
              x="1330"
              y="318"
              width="370"
              height="12"
              rx="6"
            />

            <rect
              x="1360"
              y="344"
              width="340"
              height="12"
              rx="6"
            />

            <rect
              x="1310"
              y="374"
              width="380"
              height="13"
              rx="6"
            />

            <rect
              x="1280"
              y="405"
              width="420"
              height="13"
              rx="6"
            />
          </g>

          <g>
            <circle
              cx="52"
              cy="262"
              r="22"
              fill="#9ba4b0"
            />

            <path
              d="M57 253 L48 262 L57 271"
              fill="none"
              stroke="#fff"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <animate
              attributeName="opacity"
              values=".58;1;.68;.58"
              dur="2.4s"
              begin=".6s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <circle
              cx="1802"
              cy="262"
              r="22"
              fill="#9ba4b0"
            />

            <path
              d="M1797 253 L1806 262 L1797 271"
              fill="none"
              stroke="#fff"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <animate
              attributeName="opacity"
              values=".56;1;.72;.56"
              dur="3.2s"
              begin="1.8s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="32"
              y="385"
              width="110"
              height="44"
              rx="11"
              fill="#9ba4b0"
              opacity=".75"
            />

            <text
              x="87"
              y="414"
              textAnchor="middle"
              fontFamily="Arial, Helvetica, sans-serif"
              fontSize="16"
              fill="#fff"
            >
              1 / 13
            </text>

            <animate
              attributeName="opacity"
              values=".62;1;.74;.62"
              dur="3.8s"
              begin="1.25s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <path
              d="M119 494 H110"
              fill="none"
              stroke="#aab2bd"
              strokeWidth="4"
              strokeLinecap="round"
            />

            <path
              d="M119 487 L110 494 L119 501"
              fill="none"
              stroke="#aab2bd"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <animate
              attributeName="opacity"
              values=".52;1;.67;.52"
              dur="3s"
              begin=".35s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="143"
              y="486"
              width="212"
              height="17"
              rx="8"
              fill="#d1d6de"
            />

            <animate
              attributeName="opacity"
              values=".67;1;.75;.67"
              dur="4.1s"
              begin="1.05s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="108"
              y="535"
              width="590"
              height="27"
              rx="8"
              fill="#cbd1da"
            />

            <rect
              x="108"
              y="535"
              width="590"
              height="27"
              rx="8"
              fill="url(#shine1)"
              opacity=".35"
            />

            <animate
              attributeName="opacity"
              values=".72;1;.8;.72"
              dur="3.7s"
              begin=".45s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="108"
              y="578"
              width="290"
              height="16"
              rx="8"
              fill="#d5dae2"
            />

            <rect
              x="108"
              y="578"
              width="290"
              height="16"
              rx="8"
              fill="url(#shine2)"
              opacity=".3"
            />

            <animate
              attributeName="opacity"
              values=".65;1;.72;.65"
              dur="4.4s"
              begin="1.35s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="108"
              y="618"
              width="39"
              height="20"
              rx="5"
              fill="#d5dae2"
            />

            <rect
              x="161"
              y="619"
              width="166"
              height="18"
              rx="8"
              fill="#d1d6de"
            />

            <animate
              attributeName="opacity"
              values=".62;1;.74;.62"
              dur="3.4s"
              begin=".8s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="108"
              y="664"
              width="643"
              height="80"
              rx="15"
              fill="#f2f4f7"
            />

            <animate
              attributeName="opacity"
              values=".72;1;.8;.72"
              dur="4.2s"
              begin=".7s"
              repeatCount="indefinite"
            />
          </g>

          <rect
            x="316"
            y="681"
            width="2"
            height="48"
            fill="#d2d7df"
          />

          <rect
            x="530"
            y="681"
            width="2"
            height="48"
            fill="#d2d7df"
          />

          <g>
            <rect
              x="126"
              y="685"
              width="38"
              height="34"
              rx="7"
              fill="#d0d5dd"
            />

            <path
              d="
                M134 706
                L137 697
                Q138 694 142 694
                H153
                Q157 694 158 697
                L161 706
              "
              fill="none"
              stroke="#9da6b2"
              strokeWidth="3"
            />

            <circle
              cx="139"
              cy="709"
              r="3"
              fill="#9da6b2"
            />

            <circle
              cx="155"
              cy="709"
              r="3"
              fill="#9da6b2"
            />

            <rect
              x="178"
              y="686"
              width="108"
              height="13"
              rx="7"
              fill="#cdd3dc"
            />

            <rect
              x="178"
              y="710"
              width="68"
              height="11"
              rx="6"
              fill="#d5dae2"
            />

            <animate
              attributeName="opacity"
              values=".6;1;.72;.6"
              dur="2.8s"
              begin=".55s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <circle
              cx="360"
              cy="702"
              r="18"
              fill="#d0d5dd"
            />

            <path
              d="
                M353 699 H367
                M355 704 H365
                M357 709 H363
              "
              stroke="#9da6b2"
              strokeWidth="2"
              strokeLinecap="round"
            />

            <rect
              x="392"
              y="686"
              width="108"
              height="13"
              rx="7"
              fill="#cdd3dc"
            />

            <rect
              x="392"
              y="710"
              width="68"
              height="11"
              rx="6"
              fill="#d5dae2"
            />

            <animate
              attributeName="opacity"
              values=".6;1;.7;.6"
              dur="3.5s"
              begin="1.5s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="556"
              y="685"
              width="38"
              height="34"
              rx="7"
              fill="#d0d5dd"
            />

            <path
              d="
                M563 706
                L567 697
                Q568 694 572 694
                H583
                Q587 694 588 697
                L591 706
              "
              fill="none"
              stroke="#9da6b2"
              strokeWidth="3"
            />

            <circle
              cx="569"
              cy="709"
              r="3"
              fill="#9da6b2"
            />

            <circle
              cx="585"
              cy="709"
              r="3"
              fill="#9da6b2"
            />

            <rect
              x="608"
              y="686"
              width="108"
              height="13"
              rx="7"
              fill="#cdd3dc"
            />

            <rect
              x="608"
              y="710"
              width="68"
              height="11"
              rx="6"
              fill="#d5dae2"
            />

            <animate
              attributeName="opacity"
              values=".6;1;.74;.6"
              dur="4.1s"
              begin="2.15s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="905"
              y="539"
              width="247"
              height="55"
              rx="28"
              fill="#f1f3f6"
            />

            <circle
              cx="945"
              cy="567"
              r="10"
              fill="#9da6b2"
            />

            <rect
              x="974"
              y="560"
              width="147"
              height="13"
              rx="7"
              fill="#d0d5dd"
            />

            <animate
              attributeName="opacity"
              values=".6;1;.72;.6"
              dur="3.2s"
              begin=".9s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="1170"
              y="539"
              width="247"
              height="55"
              rx="28"
              fill="#f1f3f6"
            />

            <circle
              cx="1211"
              cy="567"
              r="10"
              fill="#9da6b2"
            />

            <rect
              x="1239"
              y="560"
              width="147"
              height="13"
              rx="7"
              fill="#d0d5dd"
            />

            <animate
              attributeName="opacity"
              values=".6;1;.74;.6"
              dur="4.3s"
              begin="1.75s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="1437"
              y="539"
              width="312"
              height="55"
              rx="28"
              fill="#f1f3f6"
            />

            <circle
              cx="1479"
              cy="567"
              r="10"
              fill="#9da6b2"
            />

            <rect
              x="1507"
              y="560"
              width="210"
              height="13"
              rx="7"
              fill="#d5dae2"
            />

            <animate
              attributeName="opacity"
              values=".6;1;.72;.6"
              dur="3.6s"
              begin="2.45s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="905"
              y="667"
              width="227"
              height="71"
              rx="14"
              fill="#f1f3f6"
            />

            <rect
              x="930"
              y="691"
              width="25"
              height="25"
              rx="4"
              fill="#9da6b2"
            />

            <rect
              x="974"
              y="691"
              width="118"
              height="13"
              rx="7"
              fill="#d0d5dd"
            />

            <animate
              attributeName="opacity"
              values=".6;1;.74;.6"
              dur="3.9s"
              begin="1.45s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <rect
              x="1151"
              y="667"
              width="227"
              height="71"
              rx="14"
              fill="#f1f3f6"
            />

            <circle
              cx="1180"
              cy="704"
              r="11"
              fill="#9da6b2"
            />

            <rect
              x="1210"
              y="691"
              width="118"
              height="13"
              rx="7"
              fill="#d0d5dd"
            />

            <animate
              attributeName="opacity"
              values=".6;1;.72;.6"
              dur="3s"
              begin="2.25s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <circle
              cx="1488"
              cy="709"
              r="51"
              fill="none"
              stroke="#d6dbe2"
              strokeWidth="2"
            />

            <path
              d="
                M1462 733
                V693
                L1484 680
                V721
                Z
              "
              fill="#c8ced7"
            />

            <path
              d="
                M1484 721
                V680
                L1510 694
                V733
                Z
              "
              fill="#d2d7df"
            />

            <path
              d="
                M1453 731
                L1479 712
                L1518 734
              "
              fill="none"
              stroke="#c0c7d0"
              strokeWidth="5"
            />

            <rect
              x="1560"
              y="692"
              width="106"
              height="13"
              rx="7"
              fill="#cdd3dc"
            />

            <rect
              x="1560"
              y="716"
              width="70"
              height="11"
              rx="6"
              fill="#d5dae2"
            />

            <animate
              attributeName="opacity"
              values=".57;1;.7;.57"
              dur="4.5s"
              begin="1.05s"
              repeatCount="indefinite"
            />
          </g>
        </g>
      </svg>
    </>
  );
};

export default PreloadImovelDetail;